export { default as InsuranceRiskDashboard } from './InsuranceRiskDashboard';
